export default function ({date}) {
  if (date) {
    const dt = date.split('T');
    const tm = dt[0].split('-');
    return `${tm[1]}-${tm[2]}-${tm[0]}`
  }
  else
    return 'NA'
};